export const GROUP_NAMES_MAPPING = {
  manage_users: 'Manage Users',
  connect_with_providers: 'Connect with Providers',
  grant_clearance: 'Grant Clearance',
  schedule_shifts: 'Schedule Shifts',
  confirm_shifts: 'Confirm Shifts',
  manage_facilities: 'Manage Facilities',
  grant_presentation_approval: 'Grant Presentation Approval',
};
